import type { BridgeUnlimited, MultiRoute, RouteLeg } from '@emberswap/emberswap-sdk2/dist/entities'
import { HEXer,LiquidityProviders, PoolCode } from '@emberswap/emberswap-sdk2/dist/entities'


const exchangeUri: string =
  'https://raw.githubusercontent.com/emberswap/assets/master/blockchains/smartbch/assets/0x6BAbf5277849265b6738e75AEC43AEfdde0Ce88D/logo.png'

/**
 *
 */
export class NativeWrapBridgePoolCode extends PoolCode {
  /**
   * @param {BridgeUnlimited}pool
   * @param {LiquidityProviders}liquidityProvider
   */
  constructor(pool: BridgeUnlimited, liquidityProvider: LiquidityProviders) {
    super(pool, liquidityProvider, 'EmberSwap', exchangeUri)
  }

  /**
   * @return {string}
   */
  override getStartPoint(): string {
    return PoolCode.RouteProcessorAddress
  }



  /**
   * @param {RouteLeg}leg
   * @param {MultiRoute}_route
   * @param {string}to
   * @return {string}
   */
  getSwapCodeForRouteProcessor2(leg: RouteLeg, _route: MultiRoute, to: string): string {
    if (leg.tokenFrom.tokenId == this.pool.token0.tokenId) {
      // wrap - deposit
      const code = new HEXer()
        .uint8(2) // wrapNative pool type
        .uint8(1) // wrap action
        .address(to) // where to transfer native coin after unwrapping
        .address(this.pool.address) // wrap token
        .toString()
      return code
    } else {
      // unwrap - withdraw
      const code = new HEXer()
        .uint8(2) // wrapNative pool type
        .uint8(0) // unwrap action
        .address(to) // where to transfer native coin after unwrapping
        // .address(this.pool.address) - don't need because processToken knows the token
        .toString()
      return code
    }
  }
}
